<template>
    <common-modal width="huge" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper class="finish-early-modal" width="medium">
            <common-content-spacer height="medium">
                <common-page-header
                    size="small"
                    :heading="$t('common.microcopy.note_reservation')"
                    :isCenter="true"
                ></common-page-header>
                <div class="modal-form">
                    <form-wrapper @form-submit="submit">
                        <form-row>
                            <form-cell>
                                <textarea-input
                                    :formData="data"
                                    :isRequired="false"
                                    :maxlength="5000"
                                    :label="$t('common.microcopy.note')"
                                    :placeholder="$t('modals.confirm_reservation_modal.add_note')"
                                    valuePath="moderatorNote"
                                    @change="change"
                                ></textarea-input>
                            </form-cell>
                        </form-row>
                        <template #footer>
                            <common-buttons>
                                <common-button
                                    type="primary"
                                    :isProcessing="false"
                                    :label="$t('common.microcopy.save')"
                                ></common-button>
                            </common-buttons>
                        </template>
                    </form-wrapper>
                </div>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import CalendarEventAPI from 'api/CalendarEventAPI'

    export default {
        mixins: [FormMixin],

        props: {
            reservationId: { type: Number, default: undefined },
            moderatorNote: { type: String, default: undefined },
        },

        computed: {},

        methods: {
            submit() {
                const request = {
                    moderatorNote: this.data.moderatorNote || '',
                    calendarEventId: this.reservationId,
                }
                CalendarEventAPI.addReservationNote(request).then(() => {
                    this.$toast.success(this.$t('common.microcopy.success'))
                    this.emitEvent({ name: 'moderator-note-saved', payload: this.data.moderatorNote })
                })
            },
        },

        mounted() {
            if (this.moderatorNote?.length) {
                this.data.moderatorNote = this.moderatorNote
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
</style>
